import { Grid, Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import ActivityInSchedule from './ActivityInSchedule';
import CalendarInSchedule from './CalendarInSchedule';
import ScheduleRows from './ScheduleRows';
import ScheduleCalendar from './ScheduleCalendar';
import { useEffect, useState } from 'react';
import { format, isSameDay } from 'date-fns';
import { fr } from 'date-fns/locale';
import { getEmptyIntervals, getNextClosestDate } from '../utils/services';
import AddCourseInPlannerModal from './Modals/AddCourseInPlannerModal';
import { getAllQRCode, getClassroomDates, getClassroomPlanning, getConfigurationStatus, getDayCourses, getPeriodByDate, getPeriodSummary } from '@webapps/business';
import { useMutation, useQuery, useToast } from '@webapps/reactjs-tech-components';
import ConfirmModal from './Modals/ConfirmModal';
import NewModal from './Modals/NewModal';
import { hoursSchedule as hours } from 'config/constants';



const SchedulePlanner = ({ idParam }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const { addToast } = useToast();
  const [isAddPeriodInPlannerModalOpen, setIsAddPeriodInPlannerModalOpen] = useState(false);
  const [courseToAdd, setCourseToAdd] = useState({
    startTime: "",
    endTime: "",
    room: { label: "" },
    teacher: { label: "" },
    title: ""
  });
  const [resetEmptyCoursesSignal, setResetEmptyCoursesSignal] = useState(0);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isDeletePeriodModalOpen, setIsDeletePeriodModalOpen] = useState(false);

  const { data: allQRCode = [], refetch: refetchAllQRCode } = useQuery(getAllQRCode, {
    key: ['allQRCode', date],
    variables: { classroomId: idParam, date },
  });


  const confirmTextObject = {
    title: "Confirmation",
    description: `Voulez-vous vraiment supprimer les cours du ${format(new Date(date), "eeee d MMMM yyyy", { locale: fr })} ?`,
    confirmText: "Supprimer",
    cancelText: "Annuler"
  }

  const { data: courses = [], isLoading: isLoadingCourses, refetch: refetchCourses } = useQuery(getDayCourses, {
    key: ['dayCourses', date],
    variables: { date: date, classroomId: idParam },
  });

  const { data: periodByDate, isLoading: isLoadingPeriodByDate } = useQuery(getPeriodByDate, {
    key: ['periodByDate', date],
    variables: { id: idParam, date: date },
  });

  const { data: classroomDates = {}, isLoading: isLoadingClassroomDates } = useQuery(getClassroomDates, {
    key: ['classroomDates', date],
    variables: { classroomId: idParam },
  });

  const formattedStartDate = classroomDates?.startDate ? format(new Date(classroomDates?.startDate), "yyyy-MM-dd") : null;
  const formattedEndDate = classroomDates?.endDate ? format(new Date(classroomDates?.endDate), "yyyy-MM-dd") : null;

  const { data: configurationStatus, isLoading: isLoadingConfigurationStatus, refetch: refetchConfigurationStatus } = useQuery(getConfigurationStatus, {
    key: ['configurationStatus', date],
    variables: { id: idParam, startDate: formattedStartDate, endDate: formattedEndDate },
    enabled: Boolean(!isLoadingClassroomDates && formattedStartDate && formattedEndDate),
  });

  const allConfigurationStatus = configurationStatus ? [...configurationStatus?.configured, ...configurationStatus?.notConfigured] : [];



  const getConfigurationOfDate = (date) => {

    return allConfigurationStatus.find(configuration => configuration.date === date);
  }

  const dateConfigurationStatus = getConfigurationOfDate(date);



  useEffect(() => {
    if (!dateConfigurationStatus) {


      const nextClosestDate = getNextClosestDate(allConfigurationStatus, date);


      nextClosestDate?.date && setDate(nextClosestDate?.date);
      // filter allConfigurationStatus pour enlever les dates avant "date"

    }
  }, [configurationStatus]);



  const { data: classroomPlanning = {}, isLoading: isLoadingClassroomPlanning } = useQuery(getClassroomPlanning, {
    key: ['classroomPlanning', date],
    variables: { classroomId: idParam },
  });

  const { data: periodSummary = {}, isLoading: isLoadingPeriodSummary } = useQuery(getPeriodSummary, {
    key: ['periodSummary', date],
    variables: { classroomId: idParam, startDate: formattedStartDate, endDate: formattedEndDate },
    enabled: Boolean(!isLoadingClassroomDates && formattedStartDate && formattedEndDate),
  });




  // refresh le token toute les 10 secondes





  if (isLoadingCourses) {
    return <div>Chargement des cours...</div>;
  }

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const stringDate = capitalize(format(new Date(date), "eeee d MMMM yyyy", { locale: fr }));

  const firstClassHour = hours[0];
  const lastClassHour = hours[hours.length - 1];

  const emptyIntervals = getEmptyIntervals(courses, firstClassHour, lastClassHour);
  console.log("🚀 ~ SchedulePlanner ~ emptyIntervals:", emptyIntervals)


  const handleCancelAddPeriodInPlannerModal = () => {
    setIsAddPeriodInPlannerModalOpen(false);
    setResetEmptyCoursesSignal(prev => prev + 1);
  }

  const handleCancelDeletePeriodModal = () => {
    setIsDeletePeriodModalOpen(false);
  }

  const handleConfirmDeletePeriodModal = () => {
    setIsDeletePeriodModalOpen(false);
  }

  const handleOpenDeletePeriodModal = () => {
    setIsDeletePeriodModalOpen(true);
  }

  const emptyHours = (dateConfigurationStatus?.configuratedHours + dateConfigurationStatus?.notConfiguratedHours) - dateConfigurationStatus?.configuratedHours;


  const onSelectInterval = (course) => {

    if (emptyHours > 0) {
      addToast({
        title: "Erreur",
        description: "Nombre d'heures maximum atteint",
        type: "error"
      });
      return;
    }

    setIsAddPeriodInPlannerModalOpen(true);
    setCourseToAdd({
      startTime: course.startTime || "",
      endTime: course.endTime || "",
      room: course.room || { label: "" },
      teacher: course.teacher || { label: "" },
      title: course.title || ""
    });
  }

  const editCourse = (course) => {


    const interval = course.minuteInterval;
    const minutesRemaining = ((dateConfigurationStatus?.configuratedHours + dateConfigurationStatus?.notConfiguratedHours) - dateConfigurationStatus?.configuratedHours) * 60;

    const isEdit = course?.id




    if (!isEdit && minutesRemaining === 0) {
      addToast({
        status: 'error',
        message: "Nombre d'heures maximum atteint",
      });
      return;
    } else if (interval > Math.round(minutesRemaining)) {



      addToast({
        status: 'error',
        message: "Intervalle selectionné trop long",
      });
      return;
    }


    setCourseToAdd({
      id: course.id,
      startTime: course.startTime,
      endTime: course.endTime,
      room: course.room,
      teacher: course.teacher,
      title: course.title
    });
    setIsAddPeriodInPlannerModalOpen(true);
  }

  function formatHoursAndMinutes(hoursDecimal) {



    const heures = Math.floor(hoursDecimal);
    const minutes = Math.round((hoursDecimal - heures) * 60);
    let result = '';

    if (heures > 0 && minutes > 0) {
      result = `${heures}h${minutes.toString().padStart(2, '0')}`;
    } else if (heures > 0) {
      result = `${heures}h`;
    } else if (minutes > 0) {
      result = `${minutes}mn`;
    } else {
      result = '0h';
    }

    return result;
  }




  return (
    <div className={classes.container}>
      <Grid
        className={classes.container}
        container
      >
        <Grid item className={classes.leftColumn}>
          <div className={cx(classes.leftColumnTitle, global.headerTitle)}>
            <span>
              {stringDate} <span className={classes.dateConfigurationStatus}>{dateConfigurationStatus && `${formatHoursAndMinutes(dateConfigurationStatus?.configuratedHours)} / ${formatHoursAndMinutes(dateConfigurationStatus?.configuratedHours + dateConfigurationStatus?.notConfiguratedHours)}`}</span>
            </span>
          </div>

          {dateConfigurationStatus ? <div>
            <ScheduleRows
              hours={hours}
              courses={courses}
              emptyIntervals={emptyIntervals}
              onSelectInterval={onSelectInterval}
              editCourse={editCourse}
              resetEmptyCoursesSignal={resetEmptyCoursesSignal}
              allQRCode={allQRCode}
            />
          </div> :
            <ScheduleRows
              hours={hours}
              courses={[]}
              emptyIntervals={[{
                startTime: "8h00",
                endTime: "19h00"
              }]}
              onSelectInterval={() => { }}
              editCourse={() => { }}
              resetEmptyCoursesSignal={0}
              allQRCode={[]}
              disabledConfig={
                {
                  disabled: true,
                  message: "Aucune période configurée pour cette date"
                }
              }
            />
          }
        </Grid>

        <Grid item className={classes.rightColumn}>
          <ActivityInSchedule
            configurationStatus={isLoadingConfigurationStatus ? [] : configurationStatus?.configured}
            periods={classroomPlanning?.periods || []}
            periodSummary={periodSummary || {}}
            handleOpenDeletePeriodModal={handleOpenDeletePeriodModal}
          />
          <ScheduleCalendar
            date={date}
            setDate={setDate}
            configuratedCourses={Object.keys(courses)}
            classroomId={idParam}
            startDate={formattedStartDate}
            endDate={formattedEndDate}
            configurationStatus={isLoadingConfigurationStatus ? [] : configurationStatus?.configured}
            periods={classroomPlanning?.periods || []}
          />
        </Grid>
      </Grid>

      <AddCourseInPlannerModal
        open={isAddPeriodInPlannerModalOpen}
        onCancel={handleCancelAddPeriodInPlannerModal}
        courseToAdd={courseToAdd}
        periodByDate={periodByDate}
        date={date}
        classroomId={idParam}
        refetch={
          {
            refetchConfigurationStatus,
            refetchCourses
          }
        }
      />

      <NewModal
        open={isDeletePeriodModalOpen}
        onCancel={handleCancelDeletePeriodModal}
        title=" Etes vous sur de vouloir réinitialiser l'emploi du temps ?"
        subtitle="Toutes les périodes seront supprimées et les cours seront réinitialisés à zéro."
        image={{
          src: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png",
          srcSet: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=512 512w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png 1574w",
          sizes: "165.6842px",
          alt: "",
        }}
        actions={[
          {
            label: "Supprimer",
            onClick: handleConfirmDeletePeriodModal,
            type: "deleteButton",
          },
          {
            label: "Annuler",
            onClick: handleCancelDeletePeriodModal,
            type: "cancelButton",
          }
        ]}
      />

    </div >
  );
};

const styles = ({ spacing }) => ({
  container: {
    margin: "0px !important",
    width: 'unset',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 30,
    width: '100%',
    '@media (max-width: 1110px)': {
      flexDirection: 'column',
      gap: 0,
    },
  },
  leftColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // gap: spacing(2),
    padding: "0px !important",
    backgroundColor: 'white',
    borderRadius: "16px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    maxWidth: 'none',
    flexBasis: 'auto',
    '@media (max-width: 1110px)': {
      width: '100%',
      order: 2,
      borderRadius: "0px 0px 16px 16px",
      paddingBottom: "20px",
    },
  },
  leftColumnTitle: {
    width: "100%",
    padding: "20px",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rightColumn: {
    width: '530px',
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: "0px !important",
    maxWidth: 'none',
    flexBasis: 'auto',
    position: 'sticky',
    top: 76,
    alignSelf: 'flex-start',
    '@media (max-width: 1110px)': {
      width: '100%',
      order: 1,
      backgroundColor: 'white',
      borderRadius: "16px 16px 0px 0px",
      padding: "20px 20px 0px 20px !important",
      gap: "16px",
      position: 'static',
    },
    '@media (max-width: 960px)': {
      // marginTop: spacing(2),
    },
  },
  dateHeader: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: '#152652',
    marginBottom: spacing(2),
  },
  dateConfigurationStatus: {
    fontSize: '16px',
    fontWeight: 500,
  },
});

export default SchedulePlanner;